<div class="spinner-border text-primary" [ngClass]="classes" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
